import { gql } from '@apollo/client';
import { MenuDish } from './fragments/dish.fragment';
import { Tag } from './fragments/tag.fragment';

export default gql`
    query Dish($id: ID! $period: String!) {
        menuDish(id: $id, period: $period) {
            wideImage
            visibleStatus
            tags {
                ...tagFragment
                categoryId: category_id
                categoryName: category_name
                erp_id
            }
            ...menuDishFragment
        }
    }
    ${MenuDish}
    ${Tag}
`;
